import { ThemeConfig } from 'tailwindcss/types/config';
import { Colors } from './colors';
import { FontSizes } from './font-sizes';
import { Fonts } from './fonts';

export const theme: Partial<ThemeConfig> = {
  colors: Colors as unknown as ThemeConfig['colors'],
  fontFamily: Fonts,
  fontSize: FontSizes,
};
